/**
 * Temporary storefront reliability fix for Sky Blue Topaz Bubble Wall Ring.
 * Uses Shopify's native cart form submission so the cart is updated server-side
 * before the buyer is taken to the cart page.
 */
document.addEventListener('submit', function (event) {
  var form = event.target;
  if (!form || !form.matches('form[action*="/cart/add"]')) return;
  if (window.location.pathname.indexOf('/products/sky-blue-topaz-bubble-wall-ring') === -1) return;
  if (!form.querySelector('[name="id"]')) return;
  event.preventDefault();
  HTMLFormElement.prototype.submit.call(form);
}, true);